<template>
	<ui-card icon="fal fa-cogs" title="Configurações" text="Configurações da tabela de vendas.">
		<template #body>
			<ui-load-success v-if="loader.overlay" :loading="loader.overlayLoading" :success="loader.overlaySucess" />

			<div class="area-card">
				<transition name="small-fade">
					<div v-show="loader.body" class="loading-card">
						<ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
					</div>
				</transition>
				<ui-util-box-text-slot title="Permitir definir quais grupos de usuários podem visualizar a tabela.">
					<ui-switch design="xs" v-model="form.permissionsTableFlow" :checked="form.permissionsTableFlow" />
				</ui-util-box-text-slot>
			</div>
		</template>
		<template #fl></template>
		<template #fr v-if="$mx_userIsAdmin">
			<ui-button design="md success" :disabled="!canSubmit" @click="submit">Salvar</ui-button>
		</template>
	</ui-card>
</template>
<script>
import { uiCard } from '@/components/ui/cards'
import { uiButton } from '@/components/ui/buttons'
import { uiLoadIndicator } from '@/components/ui'
import { uiLoadSuccess } from '@/components/ui/overlays'
import { uiSwitch } from '@/components/ui/form'
import { uiUtilBoxTextSlot } from '@/components/ui/form/util'
import { salesTable } from '@/services/axios'
import { utilMixin, formMixin, alertMixin, permissionsMixin } from '@/mixins'

const defaultForm = () => ({
	permissionsTableFlow: false,
	printTableFlow: false
})

const defaultLoader = () => ({
	body: false,
	overlay: false,
	overlayLoading: true,
	overlaySucess: true,
})

export default {
	name: 'configuration-sales-table',

	components: {
		uiSwitch,
		uiCard,
		uiButton,
		uiLoadSuccess,
		uiLoadIndicator,
		uiUtilBoxTextSlot
	},

	mixins: [utilMixin, formMixin, alertMixin, permissionsMixin],

	async created() {
		this.loader.body = true
		salesTable.getTableConfigurations().then((response) => {
			let configs = response.data.data
			this.form.permissionsTableFlow = configs.find((config) => config.name == "permissionsTableFlow").active
			this.form.printTableFlow = configs.find((config) => config.name == 'printTableFlow').active
			this.$mx_copyOldForm()
		}).catch((error) =>{
			this.$mx_alertThisOnError(error)
		}).finally(() =>{
			this.loader.body = false

		})
	},

	data() {
		return {
			form: { ...defaultForm() },
			loader: { ...defaultLoader() },
			oldForm: {},
		}
	},

	computed: {
		canSubmit() {
			return (
				this.$mx_isFormChanged &&
				!this.loader.body
			)
		},
	},

	methods: {
		async submit() {
			this.loader.overlay = true
			this.loader.overlayLoading = true
			salesTable.saveTableConfigurations(this.form).then(() =>{
				this.$mx_alertSuccess('Dados salvos com sucesso.')
			}).catch(() =>{
				this.$mx_alertError('Erro ao salvar dados.')
			}).finally( () => {
				this.loader.overlay = false
				this.loader.overlayLoading = false
				this.loader.overlaySucess = false
			})
			this.$mx_copyOldForm()
		},
	},
}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
